import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getIsochroneVersionList,
  putActivateIsochroneVersion,
  putDuplicateIsochroneVersion,
  deleteBulkIsochroneVersion,
} from 'features/Location/services/isochroneVersioning'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'
import {
  SLICE_NAME,
  setIsLoading,
  setIsochroneVersionList,
  setPagination,
  setActiveVersion,
} from './slice'

export const fetchIsochroneVersionList = createAsyncThunk(
  `${SLICE_NAME}/fetchIsochroneVersionList`,
  async (_: void, { dispatch, getState }) => {
    const {
      isochroneVersioning: { query },
    } = getState() as StoreStateType

    const params = {
      limit: query.limit,
      ...(query.cursor && {
        cursor: query.cursor,
        direction: query.direction as 'next' | 'prev',
      }),
    }

    dispatch(setIsLoading(true))
    try {
      const { data } = await getIsochroneVersionList({ params })

      if (data.error?.status) {
        dispatch(setIsLoading(false))
        return
      }

      dispatch(setIsochroneVersionList(data.data.list))
      dispatch(setActiveVersion(data.data.active_version))
      dispatch(setPagination(data.pagination))
    } catch (err) {
      callErrorMsg(err)
    }
    dispatch(setIsLoading(false))
  },
)

export const duplicateIsochroneVersion = createAsyncThunk(
  `${SLICE_NAME}/duplicateIsochroneVersion`,
  async (version: string, { dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const { data } = await putDuplicateIsochroneVersion({ version })

      if (data.error?.status) {
        dispatch(setIsLoading(false))
        return
      }

      toastSuccess(data.data.message)
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))
    }
  },
)

export const deleteIsochroneVersion = createAsyncThunk(
  `${SLICE_NAME}/deleteIsochroneVersion`,
  async (id: string, { dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const { data } = await deleteBulkIsochroneVersion({ id: [id] })

      if (data.error?.status) {
        dispatch(setIsLoading(false))
        return
      }

      toastSuccess(data.data.message)
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))
    }
  },
)

export const bulkDeleteIsochroneVersion = createAsyncThunk(
  `${SLICE_NAME}/bulkDeleteIsochroneVersion`,
  async (ids: string[], { dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const { data } = await deleteBulkIsochroneVersion({ id: ids })

      if (data.error?.status) {
        dispatch(setIsLoading(false))
        return
      }

      toastSuccess(data.data.message)
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))
    }
  },
)

export const activateIsochroneVersion = createAsyncThunk(
  `${SLICE_NAME}/activateIsochroneVersion`,
  async (id: string, { dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const { data } = await putActivateIsochroneVersion({ id })

      if (data.error?.status) {
        dispatch(setIsLoading(false))
        return
      }

      toastSuccess(data.data.message)
    } catch (err) {
      callErrorMsg(err)
      dispatch(setIsLoading(false))
    }
  },
)
